import { AbstractFormatAlert } from "./AbstractFormatAlert";
import { IFormatObjectEditable } from "../IFormatObjectEditable";

export abstract class AbstractFormatObjectAlert extends AbstractFormatAlert {
  constructor(object: IFormatObjectEditable, isError: boolean) {
    super(isError);
    this._detectedObject = object.clone();
  }

  protected readonly _detectedObject: IFormatObjectEditable;
  
  get target(): string {
    return this.detectedObject.name().getValue();
  }

  get detectedObject(): IFormatObjectEditable {
    return this._detectedObject;
  }

  get ObjectKey(): number {
    return this.detectedObject.id().getValue();
  }
}
